import React, { useEffect } from 'react';

function DeleteAccount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="privacy-policy visible" style={{ opacity: 1 }}>
      <div className="container">
        <h1>מחיקת חשבון – Reado</h1>
        <p className="update-date">עודכן לאחרונה בתאריך: 03/06/2026</p>

        <div className="privacy-content">
          <p>
            אתה רשאי לבקש בכל עת את מחיקת חשבונך וכל הנתונים האישיים הקשורים אליו.
            המחיקה היא בלתי הפיכה. דף זה מסביר את שתי הדרכים לעשות זאת ומה בדיוק נמחק.
          </p>

          <section>
            <h2>1. מחיקה מתוך האפליקציה (מומלץ)</h2>
            <p>הדרך המהירה ביותר:</p>
            <ol>
              <li>פתח את אפליקציית Reado במכשירך.</li>
              <li>היכנס לחשבון שלך (אם אתה לא מחובר).</li>
              <li>פתח את לשונית <strong>"פרופיל"</strong>.</li>
              <li>לחץ על אייקון ההגדרות (גלגל שיניים) בפינה.</li>
              <li>גלול לתחתית מסך ההגדרות ולחץ על <strong>"מחק חשבון"</strong>.</li>
              <li>אשר את הפעולה בדיאלוג שייפתח.</li>
            </ol>
            <p>החשבון, הנתונים והמנוי שלך יימחקו מיידית.</p>
          </section>

          <section>
            <h2>2. מחיקה באמצעות פנייה במייל</h2>
            <p>
              אם אינך יכול לגשת לאפליקציה, או שאתה מעדיף שמישהו מהצוות יבצע את המחיקה,
              שלח אלינו מייל לכתובת:
            </p>
            <p><strong>razkl2002@gmail.com</strong></p>
            <p>בנושא ההודעה כתוב: <strong>"בקשת מחיקת חשבון Reado"</strong>.</p>
            <p>בגוף ההודעה ציין:</p>
            <ul>
              <li>כתובת המייל שאיתה נרשמת לאפליקציה.</li>
              <li>שם מלא (אם נמסר ברישום).</li>
            </ul>
            <p>אנחנו נאמת את הבעלות על החשבון ונבצע את המחיקה תוך 7 ימי עסקים.</p>
          </section>

          <section>
            <h2>3. אילו נתונים נמחקים</h2>
            <p>בעת מחיקת חשבון, אנו מוחקים את כל הנתונים הבאים:</p>
            <ul>
              <li>פרופיל המשתמש (שם, מייל, תאריך הרשמה).</li>
              <li>תשובות שאלון ההיכרות וכל ההגדרות האישיות.</li>
              <li>היסטוריית קריאה וסיכומים שנפתחו.</li>
              <li>הערות, הדגשות ושמורים אישיים.</li>
              <li>התקדמות בתרגולים יומיים ובמסע התרגול.</li>
              <li>הגדרות התראות ומזהי push.</li>
              <li>מעקב סטטיסטי על שימוש באפליקציה.</li>
              <li>חשבון האימות מ-Supabase.</li>
            </ul>
          </section>

          <section>
            <h2>4. אילו נתונים נשמרים (וחשוב לדעת)</h2>
            <p>
              חוקי המס בישראל ובחו"ל מחייבים אותנו לשמור רשומות הקשורות לעסקאות כספיות
              למשך 7 שנים. לכן הנתונים הבאים יישמרו, גם אחרי מחיקת החשבון, אך במנותק
              מהזהות שלך (anonymized):
            </p>
            <ul>
              <li>חשבוניות וקבלות שהונפקו לעסקאות הקודמות שלך.</li>
              <li>רשומות חיוב מוצפנות אצל RevenueCat ואצל Apple/Google (לפי תנאי השירות שלהם).</li>
            </ul>
          </section>

          <section>
            <h2>5. השפעה על מנוי פעיל</h2>
            <p>
              מחיקת החשבון <strong>אינה מבטלת אוטומטית את המנוי שלך</strong> ב-App Store
              או ב-Google Play. עליך לבטל את המנוי בנפרד דרך הגדרות החנות (Apple ID / חשבון
              גוגל) לפני (או אחרי) המחיקה — אחרת תיגבה גם בלי שיש לך חשבון פעיל באפליקציה.
            </p>
          </section>

          <section>
            <h2>6. יצירת קשר</h2>
            <p>
              שאלות נוספות לגבי מחיקה או פרטיות? כתוב לנו ל-
              <strong>razkl2002@gmail.com</strong> או צור קשר טלפוני: 053-5272518.
            </p>
          </section>
        </div>
      </div>
    </section>
  );
}

export default DeleteAccount;
